<div if.bind="config.panelOpen" class="modal-overlay" click.trigger="config.closePanel()">
  <div class="config-admin" click.trigger="$event.stopPropagation()">
    <div class="config-admin__header">
      <h3 class="config-admin__title">Configuration</h3>
      <button type="button" class="config-admin__close" click.trigger="config.closePanel()" aria-label="Close"><span class="icon icon--close" aria-hidden="true"></span></button>
    </div>

    <div class="config-admin__body">
      <p class="config-admin__hint">
        Every effective configuration value the app has loaded (appsettings, environment variables, user-secrets). Secret-like values are redacted.
      </p>

      <div class="config-admin__toolbar">
        <input
          type="text"
          class="config-admin__search"
          placeholder="Filter by key or value&hellip;"
          value.bind="config.search & debounce:150" />
        <span if.bind="!config.loading" class="config-admin__count">${config.filteredEntries.length} of ${config.entries.length}</span>
        <button type="button" class="login-btn login-btn--secondary" click.trigger="config.load()" disabled.bind="config.loading">Refresh</button>
      </div>

      <div if.bind="config.error" class="config-admin__error">${config.error}</div>
      <div if.bind="config.loading" class="config-admin__status">Loading configuration&hellip;</div>

      <div if.bind="!config.loading && config.filteredEntries.length === 0 && !config.error" class="config-admin__status">
        No matching configuration values.
      </div>

      <div if.bind="!config.loading && config.filteredEntries.length > 0" class="config-admin__table-wrap">
        <table class="config-admin__table">
          <thead>
            <tr>
              <th>Key</th>
              <th>Value</th>
            </tr>
          </thead>
          <tbody>
            <tr repeat.for="entry of config.filteredEntries">
              <td class="config-admin__key">${entry.key}</td>
              <td class="config-admin__value">
                <span class="config-admin__value-text">${entry.isSecret && entry.revealedValue !== undefined ? entry.revealedValue : entry.value}</span>
                <button
                  if.bind="entry.isSecret"
                  type="button"
                  class="config-admin__reveal"
                  click.trigger="entry.revealedValue === undefined ? config.reveal(entry) : config.hide(entry)"
                  disabled.bind="entry.revealing">
                  ${entry.revealing ? '…' : (entry.revealedValue === undefined ? 'Show' : 'Hide')}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
